define.alias("shared/components/shared/post/secondary/toggle", "preview-grid/components/shared/post/secondary/toggle");